module.exports = __webpack_public_path__ + "img/img-02@3x.a6b5014b.png";